import { jsxs as t, jsx as c } from "react/jsx-runtime";
const s = ({ className: a, width: l = "24", height: o = "24", onClick: r }) => /* @__PURE__ */ t(
  "svg",
  {
    className: a,
    width: l,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: r,
    children: [
      /* @__PURE__ */ c(
        "path",
        {
          d: "M12.893 5.707h-4.2c-1.153 0-1.898.002-2.464.048-.544.044-.745.12-.844.17a2 2 0 0 0-.874.874c-.05.099-.126.3-.17.844-.046.566-.048 1.31-.048 2.464v5.2c0 1.153.002 1.898.048 2.464.044.544.12.745.17.844a2 2 0 0 0 .874.874c.099.05.3.126.844.17.566.047 1.31.048 2.464.048h5.2c1.153 0 1.898-.002 2.464-.048.544-.044.745-.12.844-.17a2 2 0 0 0 .874-.874c.05-.099.126-.3.17-.844.046-.566.048-1.31.048-2.464v-4.2a1 1 0 1 1 2 0v4.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748c-.856.436-1.976.436-4.216.436h-5.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748c-.436-.856-.436-1.976-.436-4.216v-5.2c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748c.856-.436 1.976-.436 4.216-.436h4.2a1 1 0 1 1 0 2ZM19.586 5.828 21 4.414A1 1 0 0 0 19.586 3l-1.414 1.414 1.414 1.414Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ c(
        "path",
        {
          d: "m17.111 5.475-6.551 6.55a2.983 2.983 0 0 0-.874 2.11c0 .098.08.179.18.179.79 0 1.549-.315 2.108-.874l6.551-6.551-1.414-1.414Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  s as default
};
